
<!-- Quiz - Review and Submit Page -->
<section>

    <!-- Page Title -->
    <div class="title text-center content-box-header">
        <h2 class="container title bold">Module # - Quiz</h2>
        <h2 class="container sub-title bold">Review</h2>
    </div>
    <br>

    <!-- Question 1 - TRUE/FALSE -->
    <div class="content-box text-left">
        <h1 class="bolder">Question 1:</h1>
        <p class="bold question">I am a question and I want my information to be displayed here. My text wraps down the content-box in order to form two lines of this question and can go further if need be.</p>
        <input type="radio" id="answer1ID" name="q1a" value="Answer 1">
        <label class="bold">&nbsp;&nbsp;A.</label>
        <label for="answer1ID">&nbsp;&nbsp;True</label><br>
        <input type="radio" id="answer2ID" name="q1a" value="Answer 2">
        <label class="bold">&nbsp;&nbsp;B.</label>
        <label for="answer2ID">&nbsp;&nbsp;False</label>      
    </div>

    <br>

    <!-- Question 2 - TRUE/FALSE -->
    <div class="content-box text-left">
        <h1 class="bolder">Question 2:</h1>
        <p class="bold question">I am a question and I want my information to be displayed here. My text wraps down the content-box in order to form two lines of this question and can go further if need be.</p>
        <input type="radio" id="answer1ID" name="q1a" value="Answer 1">
        <label class="bold">&nbsp;&nbsp;A.</label>
        <label for="answer1ID">&nbsp;&nbsp;True</label><br>
        <input type="radio" id="answer2ID" name="q1a" value="Answer 2">
        <label class="bold">&nbsp;&nbsp;B.</label>
        <label for="answer2ID">&nbsp;&nbsp;False</label>      
    </div>

    <br>

    <!-- Question 3 - MCQ -->
    <div class="content-box text-left">
        <h1 class="bolder">Question 3:</h1>
        <p class="bold question">I am a question and I want my information to be displayed here. My text wraps down the content-box in order to form two lines of this question and can go further if need be.</p>
        <input type="radio" id="answer1ID" name="q1a" value="Answer 1">
        <label class="bold">&nbsp;&nbsp;A.</label>
        <label for="answer1ID">&nbsp;&nbsp;Answer 1</label><br>
        <input type="radio" id="answer2ID" name="q1a" value="Answer 2">
        <label class="bold">&nbsp;&nbsp;B.</label>
        <label for="answer2ID">&nbsp;&nbsp;Answer 2</label><br>
        <input type="radio" id="answer3ID" name="q1a" value="Answer 3">
        <label class="bold">&nbsp;&nbsp;C.</label>
        <label for="answer3ID">&nbsp;&nbsp;Answer 3</label><br>
        <input type="radio" id="answer4ID" name="q1a" value="Answer 4">
        <label class="bold">&nbsp;&nbsp;D.</label>
        <label for="answer4ID">&nbsp;&nbsp;Both A. and C.</label><br>
        <input type="radio" id="answer4ID" name="q1a" value="Answer 4">
        <label class="bold">&nbsp;&nbsp;E.</label>
        <label for="answer4ID">&nbsp;&nbsp;Both B. and C.</label>    
    </div>

    <br>

    <!-- Question 4 - MCQ -->
    <div class="content-box text-left">
        <h1 class="bolder">Question 4:</h1>
        <p class="bold question">I am a question and I want my information to be displayed here. My text wraps down the content-box in order to form two lines of this question and can go further if need be.</p>
        <input type="radio" id="answer1ID" name="q1a" value="Answer 1">
        <label class="bold">&nbsp;&nbsp;A.</label>
        <label for="answer1ID">&nbsp;&nbsp;Answer 1</label><br>
        <input type="radio" id="answer2ID" name="q1a" value="Answer 2">
        <label class="bold">&nbsp;&nbsp;B.</label>
        <label for="answer2ID">&nbsp;&nbsp;Answer 2</label><br>
        <input type="radio" id="answer3ID" name="q1a" value="Answer 3">
        <label class="bold">&nbsp;&nbsp;C.</label>
        <label for="answer3ID">&nbsp;&nbsp;Answer 3</label>     
    </div>

    <br>

    <!-- Question 5 - MCQ -->
    <div class="content-box text-left">
        <h1 class="bolder">Question 5:</h1>
        <p class="bold question">I am a question and I want my information to be displayed here. My text wraps down the content-box in order to form two lines of this question and can go further if need be.</p>
        <input type="radio" id="answer1ID" name="q1a" value="Answer 1">
        <label class="bold">&nbsp;&nbsp;A.</label>
        <label for="answer1ID">&nbsp;&nbsp;Answer 1</label><br>
        <input type="radio" id="answer2ID" name="q1a" value="Answer 2">
        <label class="bold">&nbsp;&nbsp;B.</label>
        <label for="answer2ID">&nbsp;&nbsp;Answer 2</label><br>
        <input type="radio" id="answer3ID" name="q1a" value="Answer 3">
        <label class="bold">&nbsp;&nbsp;C.</label>
        <label for="answer3ID">&nbsp;&nbsp;Answer 3</label><br>
        <input type="radio" id="answer4ID" name="q1a" value="Answer 4">
        <label class="bold">&nbsp;&nbsp;D.</label>
        <label for="answer4ID">&nbsp;&nbsp;Answer 4</label><br>
        <input type="radio" id="answer5ID" name="q1a" value="Answer 5">
        <label class="bold">&nbsp;&nbsp;E.</label>
        <label for="answer5ID">&nbsp;&nbsp;All of the Above</label>      
    </div>

    <br>

    <!-- Question 6 - TRUE/FALSE -->
    <div class="content-box text-left">
        <h1 class="bolder">Question 6:</h1>
        <p class="bold question">I am a question and I want my information to be displayed here. My text wraps down the content-box in order to form two lines of this question and can go further if need be.</p>
        <input type="radio" id="answer1ID" name="q1a" value="Answer 1">
        <label class="bold">&nbsp;&nbsp;A.</label>
        <label for="answer1ID">&nbsp;&nbsp;True</label><br>
        <input type="radio" id="answer2ID" name="q1a" value="Answer 2">
        <label class="bold">&nbsp;&nbsp;B.</label>
        <label for="answer2ID">&nbsp;&nbsp;False</label>      
    </div>

    <br>

    <!-- Question 7 - MCQ -->
    <div class="content-box text-left">
        <h1 class="bolder">Question 7:</h1>
        <p class="bold question">I am a question and I want my information to be displayed here. My text wraps down the content-box in order to form two lines of this question and can go further if need be.</p>
        <input type="radio" id="answer1ID" name="q1a" value="Answer 1">
        <label class="bold">&nbsp;&nbsp;A.</label>
        <label for="answer1ID">&nbsp;&nbsp;Answer 1</label><br>
        <input type="radio" id="answer2ID" name="q1a" value="Answer 2">
        <label class="bold">&nbsp;&nbsp;B.</label>
        <label for="answer2ID">&nbsp;&nbsp;Answer 2</label><br>
        <input type="radio" id="answer3ID" name="q1a" value="Answer 3">
        <label class="bold">&nbsp;&nbsp;C.</label>
        <label for="answer3ID">&nbsp;&nbsp;Answer 3</label><br>
        <input type="radio" id="answer4ID" name="q1a" value="Answer 4">
        <label class="bold">&nbsp;&nbsp;D.</label>
        <label for="answer4ID">&nbsp;&nbsp;Answer 4</label>     
    </div>

    <br>

    <!-- Question 8 - TRUE/FALSE -->
    <div class="content-box text-left">
        <h1 class="bolder">Question 8:</h1>
        <p class="bold question">I am a question and I want my information to be displayed here. My text wraps down the content-box in order to form two lines of this question and can go further if need be.</p>
        <input type="radio" id="answer1ID" name="q1a" value="Answer 1">
        <label class="bold">&nbsp;&nbsp;A.</label>
        <label for="answer1ID">&nbsp;&nbsp;True</label><br>
        <input type="radio" id="answer2ID" name="q1a" value="Answer 2">
        <label class="bold">&nbsp;&nbsp;B.</label>
        <label for="answer2ID">&nbsp;&nbsp;False</label>      
    </div>

    <br>

    <!-- Question 9 - MCQ -->
    <div class="content-box text-left">
        <h1 class="bolder">Question 9:</h1>
        <p class="bold question">I am a question and I want my information to be displayed here. My text wraps down the content-box in order to form two lines of this question and can go further if need be.</p>
        <input type="radio" id="answer1ID" name="q1a" value="Answer 1">
        <label class="bold">&nbsp;&nbsp;A.</label>
        <label for="answer1ID">&nbsp;&nbsp;Answer 1</label><br>
        <input type="radio" id="answer2ID" name="q1a" value="Answer 2">
        <label class="bold">&nbsp;&nbsp;B.</label>
        <label for="answer2ID">&nbsp;&nbsp;Answer 2</label><br>
        <input type="radio" id="answer3ID" name="q1a" value="Answer 3">
        <label class="bold">&nbsp;&nbsp;C.</label>
        <label for="answer3ID">&nbsp;&nbsp;Answer 3</label><br>
        <input type="radio" id="answer4ID" name="q1a" value="Answer 4">
        <label class="bold">&nbsp;&nbsp;D.</label>
        <label for="answer4ID">&nbsp;&nbsp;Answer 4</label><br>
        <input type="radio" id="answer5ID" name="q1a" value="Answer 5">
        <label class="bold">&nbsp;&nbsp;E.</label>
        <label for="answer5ID">&nbsp;&nbsp;All of the Above</label>      
    </div>

    <br>

    <!-- Question 10 - TRUE/FALSE -->
    <div class="content-box text-left">
        <h1 class="bolder">Question 10:</h1>
        <p class="bold question">I am a question and I want my information to be displayed here. My text wraps down the content-box in order to form two lines of this question and can go further if need be.</p>
        <input type="radio" id="answer1ID" name="q1a" value="Answer 1">
        <label class="bold">&nbsp;&nbsp;A.</label>
        <label for="answer1ID">&nbsp;&nbsp;True</label><br>
        <input type="radio" id="answer2ID" name="q1a" value="Answer 2">
        <label class="bold">&nbsp;&nbsp;B.</label>
        <label for="answer2ID">&nbsp;&nbsp;False</label>      
    </div>

    <!-- Navigation Buttons -->
    <div class="container text-center">
        <!-- Need to add spacing in css file-->
        <br>
        <br>
        <br>
        <button type="button" class="btn waves-dark">RETURN TO QUIZ</button>
        <button type="button" class="btn waves-dark">SAVE AND SUBMIT</button>
    </div>
</section>